import React, {useEffect, useState} from "react";
import {Button, CardContent, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import PageLayout from "../components/layout/PageLayout";
import {fetchCurrencies, selectCurrencies} from "../store/currencySlice";
import {useDispatch, useSelector} from "react-redux";
import {AddCircle} from "@mui/icons-material";
import EditCurrencyForm from "../components/form/EditCurrencyForm";
import CurrencyService from "../services/CurrencyService";
import {useTranslation} from "react-i18next";


const CurrenciesPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const currencies = useSelector(state => selectCurrencies(state));
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    useEffect(() => {
        dispatch(fetchCurrencies());
    }, []);

    return (
        <PageLayout title={t("pages.currencies.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: "82vh", overflow: "scroll"}}>
                <TableContainer>
                    <Table sx={{maxWidth: 650}} aria-label="simple table">
                        <TableBody>
                            {CurrencyService.getActive(currencies).map((currency) =>
                                <TableRow
                                    key={currency.id}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                    onClick={(event) => setSelectedCurrency(currency)}
                                >
                                    <TableCell component="th" scope="row">
                                        {currency.name}
                                    </TableCell>
                                    <TableCell align="right">{currency.shortName}</TableCell>
                                    <TableCell align="right">{currency.code}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Button style={{position: "absolute", bottom: 30, right: "45%", fontSize: "4rem"}}
                        onClick={(event) => setSelectedCurrency({name: "", shortName: "", code: ""})}>
                    <AddCircle fontSize="inherit"/>
                </Button>
            </CardContent>
            {selectedCurrency && <EditCurrencyForm currency={selectedCurrency}
                                                   onCancel={(e) => setSelectedCurrency(null)}></EditCurrencyForm>}
        </PageLayout>
    );
}

export default CurrenciesPage